export const appTypes = {
	SET_NOTIFICATION: "SET_NOTIFICATION",
	SET_CAMPAIGN_USERS: "SET_CAMPAIGN_USERS",
	DELETE_NOTIFICATION: "DELETE_NOTIFICATION",
	SET_SCHEMAS_PULL: "SET_SCHEMAS_PULL",
	SET_AUDIO_PLAYER: "SET_AUDIO_PLAYER"
};
